/**
 * WelcomeDialog - Handles the welcome/onboarding dialog
 */

import * as d3 from 'd3';
import { getLastSearchedBib, saveLastSearchedBib } from '../utils/storage';
import { AnalyticsService } from '../services/AnalyticsService';

export class WelcomeDialog {
    private analytics: AnalyticsService;
    private onStartWithBib: (bib: string) => void;
    private onStartDemo: () => void;

    constructor(
        analytics: AnalyticsService,
        onStartWithBib: (bib: string) => void,
        onStartDemo: () => void
    ) {
        this.analytics = analytics;
        this.onStartWithBib = onStartWithBib;
        this.onStartDemo = onStartDemo;
        this.init();
    }

    private init(): void {
        this.show();
        this.setupEventListeners();
        this.restoreLastBib();
    }

    private show(): void {
        d3.select('#welcome-dialog').classed('hidden', false);
    }

    private hide(): void {
        d3.select('#welcome-dialog').classed('hidden', true);
    }

    private restoreLastBib(): void {
        const lastBib = getLastSearchedBib();
        if (lastBib) {
            d3.select('#welcome-bib-input').property('value', lastBib);
        }
    }

    private setupEventListeners(): void {
        d3.select('#close-welcome').on('click', () => {
            this.hide();
        });

        d3.select('#start-with-bib').on('click', () => {
            const bibNumber = d3.select('#welcome-bib-input').property('value').trim();
            this.hide();

            if (bibNumber) {
                saveLastSearchedBib(bibNumber);
                d3.select('#athlete-search').property('value', bibNumber);
                this.onStartWithBib(bibNumber);

                this.analytics.logWelcomeAction('start_with_bib', true);
            }

            setTimeout(() => {
                this.onStartDemo();
            }, 500);
        });

        d3.select('#start-demo').on('click', () => {
            this.hide();
            this.analytics.logWelcomeAction('start_demo', false);

            setTimeout(() => {
                this.onStartDemo();
            }, 500);
        });

        d3.select('#welcome-bib-input').on('keypress', (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                (d3.select('#start-with-bib').node() as HTMLElement)?.click();
            }
        });
    }
}
